export default ['independent', 'supervised', 'graduated'];
